/* eslint-disable @typescript-eslint/no-empty-function */
import { default as config } from "common/config/config";
import type { Locale } from "common/models/settings/Settings";
import { LanguageDetectorAsyncModule } from "i18next";
import { settingsService } from "features/settings/services/settingsService";
import getBrowserLocale from "../utils/getBrowserLocale";

export function getDefaultLocale(): Locale {
    const supportedLocales: Locale[] = ["es"];
    const defaultLocale = getBrowserLocale();
    const systemLocaleEnd = defaultLocale.slice(-2).toLowerCase();
    const systemLocaleStart = defaultLocale.slice(0, 2).toLowerCase();
    return supportedLocales.find((l) => systemLocaleStart === l || systemLocaleEnd === l) ?? (config.defaultLocale as Locale);
}

export async function detect(): Promise<Locale> {
    try {
        // TODO : get locale from user settings and veridy it is supported
        const storedLocale = await settingsService.getLocale();
        return storedLocale || getDefaultLocale();
    } catch (error) {
        /* eslint-disable no-console */
        console.warn("Error reading language", error);
        return "en";
    }
}

const LanguageDetectorPlugin: LanguageDetectorAsyncModule = {
    type: "languageDetector",
    async: true,
    init: () => {},
    detect,
    cacheUserLanguage: () => {},
};

export default LanguageDetectorPlugin;
